// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VU9t","image":"Header_image__2AE_y","name":"Header_name__5j-7j","info":"Header_info__1PyaK","infoRow":"Header_infoRow__1P180"};